// import _ from 'lodash';

const products = {
  loading: false,
  loadingFull: false,
  discountPrice: false,
  allProductPricesLoading: false,
  cocktailsLoading: false,
  promotionsLoading: false,
  replacementsLoading: false,
  active: '',
  category: '',
  productRules: [],
  displayedList: [],
  productsRulesList: [],
  list: {},
  scrollableList: {},
  newArrivalList: null,
  onSpecialList: null,
  featuredList: {},
  filters: {},
  hasActiveFilters: false,
  productGridModalId: 0,
  productGridModalSelectedTab: '',
  toggleProductTemplateLoading: false,
  removeTemplateLoading: false,
  removeNotifyLoading: false,
  loyaltyBox: {
    list: [],
    isLoading: true,
    activeProduct: null,
    showProductModal: false,
  },
}
const ProductsReducer = function (state = products, action) {
  switch (action.type) {
    case 'TOGGLE_ACTIVE_FILTERS': {
      return {
        ...state,
        hasActiveFilters: action.value,
      }
    }
    case 'TOGGLE_DISCOUNT_PRICE_LOADING': {
      return {
        ...state,
        discountPrice: action.value,
      }
    }
    case 'TOGGLE_FILTER': {
      return {
        ...state,
        filters: action.value,
      }
    }
    case 'SET_PRODUCTS_FILTERS': {
      return {
        ...state,
        filters: action.value,
      }
    }
    case 'APPEND_PRODUCTS_FILTERS': {
      let newFilters = { ...state.filters }
      Object.entries(action.value).forEach(([filterKey, filterList]) => {
        newFilters[filterKey] =
          typeof newFilters[filterKey] == 'undefined' ? filterList : { ...filterList, ...newFilters[filterKey] }
      })
      return {
        ...state,
        filters: newFilters,
      }
    }
    case 'TOGGLE_PRODUCTS_LOADING': {
      return {
        ...state,
        loading: action.value,
      }
    }
    case 'TOGGLE_PRODUCTS_TEMPLATE_LOADING': {
      return {
        ...state,
        toggleProductTemplateLoading: action.value,
      }
    }
    case 'REMOVE_TEMPLATE_LOADING': {
      return {
        ...state,
        removeTemplateLoading: action.value,
      }
    }
    case 'REMOVE_NOTIFY_LOADING': {
      return {
        ...state,
        removeNotifyLoading: action.value,
      }
    }

    case 'TOGGLE_PRODUCTS_FULL_LOADING': {
      return {
        ...state,
        loadingFull: action.value,
      }
    }
    case 'TOGGLE_FULL_PRODUCT_PRICES_LOADING': {
      return {
        ...state,
        allProductPricesLoading: action.value,
      }
    }
    case 'TOGGLE_PRODUCT_COCKTAILS_LOADING': {
      return {
        ...state,
        cocktailsLoading: action.value,
      }
    }
    case 'TOGGLE_PRODUCT_PROMOTIONS_LOADING': {
      return {
        ...state,
        promotionsLoading: action.value,
      }
    }
    case 'TOGGLE_PRODUCT_REPLACEMENTS_LOADING': {
      return {
        ...state,
        replacementsLoading: action.value,
      }
    }
    case 'SET_ACTIVE_CATEGORY': {
      return {
        ...state,
        category: action.category,
      }
    }
    case 'SET_PRODUCTS_LIST': {
      return {
        ...state,
        list: action.list,
      }
    }
    case 'SET_NEW_ARRIVAL_LIST': {
      return {
        ...state,
        newArrivalList: action.list,
      }
    }
    case 'SET_ON_SPECIAL_LIST': {
      return {
        ...state,
        onSpecialList: action.list,
      }
    }
    case 'SET_PRODUCTS_RULES': {
      return {
        ...state,
        productRules: action.list,
      }
    }
    case 'UPDATE_PRODUCTS_LIST': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))
      return {
        ...state,
        list: {
          ...state.list,
          ...newList,
        },
      }
    }
    case 'SET_PRODUCTS_RULES_LIST': {
      return {
        ...state,
        productsRulesList: action.list,
      }
    }
    case 'UPDATE_PRODUCTS_SCROLLABLE_LIST': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))
      return {
        ...state,
        scrollableList: {
          ...state.scrollableList,
          [action.blockID]: newList,
        },
      }
    }
    case 'UPDATE_FEATURED_LIST': {
      let newList = {}
      Object.entries(action.list).forEach(
        ([key, value]) => (newList[key] = { ...state.featuredList[key], id: value.id })
      )
      return {
        ...state,
        featuredList: {
          ...state.featuredList,
          ...newList,
        },
      }
    }
    case 'REMOVE_PRODUCTS_LIST': {
      return {
        ...state,
        list: Object.entries(action.list).reduce((accumulator, [key, value]) => {
          const { [key]: removedItem, ...rest } = accumulator
          // console.log('Removed item', removedItem);
          return rest
        }, state),
      }
    }
    case 'UPDATE_COCKTAILS_LIST': {
      return {
        ...state,
        list: {
          ...state.list,
          [action.product]: {
            ...state.list[action.product],
            cocktails: Object.keys(action.list),
          },
        },
      }
    }
    case 'UPDATE_PROMOTIONS_LIST': {
      return {
        ...state,
        list: {
          ...state.list,
          [action.product]: {
            ...state.list[action.product],
            promotions: Object.keys(action.list),
          },
        },
      }
    }
    case 'UPDATE_REPLACEMENTS_LIST': {
      return {
        ...state,
        list: {
          ...state.list,
          ...action.list,
          [action.product]: {
            ...state.list[action.product],
            replacements: Object.keys(action.list),
          },
        },
      }
    }
    case 'UPDATE_PRODUCT_GRID_DETAILS': {
      return {
        ...state,
        loyaltyBox: {
          ...state.loyaltyBox,
          [action.key]: action.value,
        },
      }
    }
    case 'ADD_PRODUCT_GRID_LIST': {
      return {
        ...state,
        loyaltyBox: {
          ...state.loyaltyBox,
          list: [...action.value, ...state.loyaltyBox.list],
        },
      }
    }
    default: {
      return state
    }
  }
}

export default ProductsReducer
